import type { Theme } from "@/lib/theme/type";
import { rgb } from "@/utils/color";
import type { CssVars } from "@/utils/css-vars";

export function convertThemeToCssVars(theme: Theme): CssVars {
  return reduce(theme);
}

function reduce(object: object, acc?: CssVars, previousKey?: string): CssVars {
  return Object.entries(object).reduce<CssVars>(
    (acc, [key, value]) => perform(acc, [key, value], previousKey),
    acc ?? {},
  );
}

function perform(acc: CssVars, [key, value]: [string, unknown], previousKey?: string): CssVars {
  const currentKey = [previousKey, key].filter(Boolean).join("-");

  if (typeof value === "string") {
    acc[`--${currentKey}`] = value;
    return acc;
  }

  if (typeof value === "object") {
    return reduce(value as object, acc, currentKey);
  }

  return acc;
}

export function appendRgbToCssVars(cssVars: CssVars): CssVars<`--${string}` | `--${string}-rgb`> {
  return Object.entries(cssVars).reduce(
    (acc, [key, value]) => {
      const typedKey = key as `--${string}`;
      acc[typedKey] = value;
      acc[`${typedKey}-rgb`] = rgb(value);
      return acc;
    },
    {} as CssVars<`--${string}` | `--${string}-rgb`>,
  );
}
